<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon :color="color" v-on="on">{{ icon }}</v-icon>
    </template>
    <span>{{ description }}</span>
  </v-tooltip>
</template>

<script>
const MAP_ICONS = {
  SOLICITADO: {
    icon: 'mdi-handshake',
    color: 'amber darken-1',
    message: 'Negociação aguardando resposta',
  },
  RESPONDIDO: {
    icon: 'mdi-handshake',
    color: 'blue lighten-1',
    message: 'Negociação respondida',
  },
};

export default {
  props: {
    statusNegociacao: String,
  },
  computed: {
    description() {
      if (!this.statusNegociacao) {
        return null;
      }
      return MAP_ICONS[this.statusNegociacao].message;
    },
    color() {
      if (!this.statusNegociacao) {
        return null;
      }
      return MAP_ICONS[this.statusNegociacao].color;
    },
    icon() {
      if (!this.statusNegociacao) {
        return null;
      }
      return MAP_ICONS[this.statusNegociacao].icon;
    },
  },
};
</script>
